import { Center } from "@chakra-ui/react";
import { CartesianGrid, Line, LineChart, XAxis, YAxis } from "recharts";

import { QuestionDto } from "../model/Dto";

type CCIGraphProps = {
  dataset: any;
  questions: QuestionDto[];
  selectedQuestionId?: string;
};

const CCIGraph = ({
  dataset,
  questions,
  selectedQuestionId,
}: CCIGraphProps) => {
  return (
    <Center padding="5">
      <LineChart
        width={730}
        height={250}
        data={dataset}
        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        {questions?.map((question) => (
          <>
            <Line
              key={`p${question.id}`}
              type="monotone"
              dataKey={`p${question.id}`}
              stroke={
                selectedQuestionId === question.id ? "#bf874e" : "#8884d8"
              }
              strokeWidth={selectedQuestionId === question.id ? 3 : 1}
              dot={false}
            />
            <Line
              key={`i${question.id}`}
              type="monotone"
              dataKey={`i${question.id}`}
              stroke={
                selectedQuestionId === question.id ? "#ca9082" : "#82ca9d"
              }
              strokeWidth={selectedQuestionId === question.id ? 3 : 1}
              dot={false}
            />
          </>
        ))}
      </LineChart>
    </Center>
  );
};

export default CCIGraph;
